import styled from "styled-components";

export const MainHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const Subtitle = styled.div`
  @media only screen and (max-width: 875px) {
    display: none;
  }
`;
